import { observer } from 'mobx-react-lite'
import React from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { AssignInboxTwilioVendor } from 'entities/Phone/ui/actions/assignInbox/ui/ui/AssignInboxTwilioVendor/AssignInboxTwilioVendor'
import { AssignInboxDefault } from './AssignInboxDefault/AssignInboxDefault'
import { type AssignInboxStore } from '../store/AssignInboxStore'

type IAssignInboxModalProps = {
  assignInboxStore: AssignInboxStore
}

export const AssignInboxModal = observer(({ assignInboxStore }: IAssignInboxModalProps) => {
  const { organizationStore } = useEntitiesContext()
  return organizationStore.isTwilioNumberVendor ? (
    <AssignInboxTwilioVendor assignInboxStore={assignInboxStore} />
  ) : (
    <AssignInboxDefault assignInboxStore={assignInboxStore} />
  )
})
